/* maybe-micro.js
   Micro-interactions for maybe.nyc (added 26 Sep 2026). Pairs with
   maybe-micro.css. Movement only when <html> has .mm-motion; the size
   preview and frame chips help everyone and always run. */
(function () {
  'use strict';

  var root = document.documentElement;
  var motion = root.classList.contains('mm-motion');
  var finePointer = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function replay(el, cls, ms) {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    clearTimeout(el['mmT' + cls]);
    el['mmT' + cls] = setTimeout(function () { el.classList.remove(cls); }, ms);
  }

  /* ---------- Product page: size preview, frame chips, price change ---------- */

  // "8x10", "20x25 cm / 8x10″", "A4 21x29.7 cm / 8x12″" -> [8, 10] in inches
  function inches(value) {
    var re = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*(″|"|in\b)?/gi, m, plain = null, marked = null;
    while ((m = re.exec(value))) {
      if (m[3]) marked = m;
      else if (!/cm/i.test(value.slice(m.index + m[0].length, m.index + m[0].length + 4))) plain = m;
    }
    var hit = marked || plain;
    if (!hit) return null;
    var a = parseFloat(hit[1]), b = parseFloat(hit[2]);
    return [Math.min(a, b), Math.max(a, b)];
  }

  function variantGroup(variants, word) {
    var groups = variants.querySelectorAll('.product-variant');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var name = (g.dataset.name || '') + ' ' + ((g.querySelector('.product-variant__name') || {}).textContent || '');
      if (name.toLowerCase().indexOf(word) > -1) return g;
    }
    return null;
  }

  function checkedValue(group) {
    var input = group && group.querySelector('input:checked');
    return input ? input.value : '';
  }

  var PX_PER_INCH = 1.5; // the sofa below is a typical 84 in wide

  function sizePreview(variants) {
    var group = variantGroup(variants, 'size');
    if (!group) return;
    var size = inches(checkedValue(group));
    var preview = group.querySelector('.mm-size');
    if (!size) { if (preview) preview.remove(); return; }
    if (!preview) {
      preview = document.createElement('div');
      preview.className = 'mm-size';
      // Only the drawing is hidden from screen readers; the size text is useful to everyone.
      preview.innerHTML = '<div class="mm-size__scene" aria-hidden="true"><div class="mm-size__sofa"></div><div class="mm-size__print"></div></div>' +
        '<div class="mm-size__text"><strong></strong><span>Print size, shown above a typical 84 in sofa</span></div>';
      group.appendChild(preview);
    }
    var frameGroup = variantGroup(variants, 'frame');
    var framed = frameGroup && !/unframed/i.test(checkedValue(frameGroup));
    var print = preview.querySelector('.mm-size__print');
    print.style.setProperty('--w', Math.round(size[0] * PX_PER_INCH) + 'px');
    print.style.setProperty('--h', Math.round(size[1] * PX_PER_INCH) + 'px');
    print.classList.toggle('is-framed', !!framed);
    var text = size[0] + ' × ' + size[1] + ' in';
    var strong = preview.querySelector('strong');
    if (strong.textContent !== text) strong.textContent = text; // no-op writes would retrigger the observer
  }

  function chipTone(value) {
    var v = value.toLowerCase();
    if (/unframed|no frame/.test(v)) return 'none';
    if (/black/.test(v)) return '#1f1c19';
    if (/white/.test(v)) return '#f3efe6';
    if (/natural|wood|oak/.test(v)) return '#c49a6c';
    return null;
  }

  function frameChips(variants) {
    var group = variantGroup(variants, 'frame');
    if (!group) return;
    group.querySelectorAll('.product-variant__item').forEach(function (item) {
      var input = item.querySelector('input');
      var label = item.querySelector('label');
      if (!input || !label || label.querySelector('.mm-chip')) return;
      var tone = chipTone(input.value);
      if (!tone) return;
      var chip = document.createElement('span');
      chip.setAttribute('aria-hidden', 'true');
      if (tone === 'none') {
        chip.className = 'mm-chip mm-chip--none';
      } else {
        chip.className = 'mm-chip';
        chip.style.setProperty('--chip', tone);
        if (tone === '#f3efe6') chip.style.setProperty('--chip-edge', '#8a8275'); // 3.6:1 against the page
      }
      label.insertBefore(chip, label.firstChild);
    });
  }

  function enhanceVariants() {
    document.querySelectorAll('product-variants[data-main-product-variants]').forEach(function (v) {
      frameChips(v);
      sizePreview(v);
    });
  }

  var lastPrice = new WeakMap();
  function priceChanged(el) {
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    var before = lastPrice.get(el);
    lastPrice.set(el, text);
    if (motion && before !== undefined && before !== text) replay(el, 'mm-price-change', 600);
  }

  function watchProduct() {
    var pages = document.querySelectorAll('product-page, [data-js-product-page], .product-page');
    var scope = pages.length ? pages : [document.getElementById('main')].filter(Boolean);
    scope.forEach(function (page) {
      page.querySelectorAll('[data-update-block^="price"]').forEach(priceChanged);
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          enhanceVariants();
          page.querySelectorAll('[data-update-block^="price"]').forEach(priceChanged);
        });
      }).observe(page, { childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('product-variants')) requestAnimationFrame(enhanceVariants);
    });
  }

  // The Cold Press prints' titles read "Series — Name | Black Fine Art Print" (used by search below).
  var TITLE_RE = /^\s*(.+?)\s+—\s+(.+?)\s*\|\s*Black Fine Art Print\s*$/;

  /* ---------- Cart drawer: fold removed lines, count the total ---------- */

  document.addEventListener('click', function (e) {
    if (!motion) return;
    var remove = e.target.closest && e.target.closest('.cart-item .remove');
    if (!remove) return;
    var item = remove.closest('.cart-item');
    if (!item || item.classList.contains('mm-removing') || !item.animate) return;
    item.classList.add('mm-removing');
    item.animate([
      { opacity: 1, height: item.offsetHeight + 'px' },
      { opacity: 0, height: '0px', paddingTop: '0px', paddingBottom: '0px' }
    ], { duration: 380, easing: 'cubic-bezier(.22,.61,.21,1)', fill: 'forwards' });
  }, true);

  function money(text) {
    var m = text.match(/\d[\d,]*(?:\.\d+)?/);
    return m ? { value: parseFloat(m[0].replace(/,/g, '')), raw: m[0] } : null;
  }

  function fmt(value, like) {
    var decimals = (like.split('.')[1] || '').length;
    var s = value.toFixed(decimals);
    if (like.indexOf(',') > -1) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return s;
  }

  var lastTotal = null;
  function countTotal() {
    var el = document.querySelector('#AjaxCartSubtotal .cart__total strong');
    if (!el || el.mmCounting) return; // our own writes while counting
    var finalText = el.textContent;
    var to = money(finalText);
    var from = lastTotal;
    lastTotal = to;
    if (!motion || !from || !to || from.value === to.value) return;
    el.mmCounting = true;
    // Screen readers only ever get the real total: the counting copy is hidden from
    // them, and the final value sits in a visually hidden span next to it.
    var shown = document.createElement('span');
    shown.setAttribute('aria-hidden', 'true');
    var real = document.createElement('span');
    real.className = 'mm-sr';
    real.textContent = finalText;
    // Observers run before the next paint, so the old total shows first, not the new one.
    shown.textContent = finalText.replace(to.raw, fmt(from.value, to.raw));
    el.textContent = '';
    el.appendChild(shown);
    el.appendChild(real);
    var start = null, dur = 600;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      if (!el.isConnected || !shown.isConnected) { el.mmCounting = false; return; }
      if (t < 1) {
        shown.textContent = finalText.replace(to.raw, fmt(from.value + (to.value - from.value) * e, to.raw));
        requestAnimationFrame(step);
      } else {
        el.textContent = finalText;
        setTimeout(function () { el.mmCounting = false; }, 0);
      }
    }
    requestAnimationFrame(step);
  }

  function watchCart() {
    var sub = document.getElementById('AjaxCartSubtotal');
    var el = sub && sub.querySelector('.cart__total strong');
    lastTotal = el ? money(el.textContent) : null;
    if (sub) new MutationObserver(function () { countTotal(); }).observe(sub, { childList: true, subtree: true });
  }

  /* ---------- Toggles: mark as touched so only real clicks animate ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('toggle-tab [data-js-title]');
    if (t) t.closest('toggle-tab').classList.add('mm-touched');
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target.closest && e.target.closest('toggle-tab [data-js-title]');
    if (t) t.closest('toggle-tab').classList.add('mm-touched');
  }, true);

  /* ---------- Header line on scroll ---------- */

  var scrolled = null;
  function onScroll() {
    var s = window.scrollY > 12;
    if (s !== scrolled) { scrolled = s; root.classList.toggle('mm-scrolled', s); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Newsletter: send nudge ---------- */

  document.addEventListener('submit', function (e) {
    if (!motion) return;
    var form = e.target;
    if (form.closest && form.closest('.newsletter') && form.checkValidity()) {
      var fs = form.querySelector('fieldset');
      if (fs) replay(fs, 'mm-sending', 800);
    }
  }, true);

  /* ---------- "View" cursor over print cards ---------- */

  function viewCursor() {
    if (!motion || !finePointer) return;
    // High-contrast modes repaint our dot and would leave no visible pointer: keep the system cursor.
    if (matchMedia('(forced-colors: active)').matches || matchMedia('(prefers-contrast: more)').matches) return;
    var dot = document.createElement('div');
    dot.className = 'mm-cursor';
    dot.setAttribute('aria-hidden', 'true');
    dot.textContent = 'View';
    document.body.appendChild(dot);
    root.classList.add('mm-cursor-zone');
    var x = 0, y = 0, cx = 0, cy = 0, on = false, raf = null;
    function loop() {
      cx += (x - cx) * 0.25;
      cy += (y - cy) * 0.25;
      dot.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)';
      if (on || Math.abs(x - cx) > .5 || Math.abs(y - cy) > .5) raf = requestAnimationFrame(loop);
      else raf = null;
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      var t = e.target;
      var card = t.closest && t.closest('#main .product-item');
      var inThumb = false;
      if (card && !t.closest('.product-item__quick-buy')) {
        var thumb = card.querySelector('.product-item__thumbnail');
        if (thumb) {
          var r = thumb.getBoundingClientRect();
          inThumb = x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
        }
      }
      if (inThumb && !on) { cx = x; cy = y; }
      on = inThumb;
      dot.classList.toggle('is-on', on);
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    document.addEventListener('pointerleave', function () { on = false; dot.classList.remove('is-on'); });
    window.addEventListener('scroll', function () { if (on) { on = false; dot.classList.remove('is-on'); } }, { passive: true });
  }

  /* ---------- Search: the placeholder suggests real print names ---------- */

  function searchPlaceholder() {
    if (!motion) return;
    var drawer = document.getElementById('site-search-sidebar');
    var input = document.getElementById('search-form-sidebar');
    if (!drawer || !input) return;
    var original = input.getAttribute('placeholder') || '';
    var names = null, timer = null, i = 0, shownThisOpen = 0, startedAt = 0;
    var MAX_NAMES = 2;
    var MAX_MS = 5000; // then it stops by itself: nothing changes on its own for longer than 5 seconds

    function load() {
      if (names) return Promise.resolve(names);
      return fetch('/collections/all/products.json?limit=50')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          names = [];
          (d.products || []).forEach(function (p) {
            var m = p.title.match(TITLE_RE);
            if (m) names.push(m[2]);
          });
          names = names.sort(function () { return Math.random() - .5; }).slice(0, 8);
          return names;
        })
        .catch(function () { names = []; return names; });
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
      input.setAttribute('placeholder', original);
    }

    function type(word, n, done) {
      if (!drawer.classList.contains('sidebar--opened') || input.value || Date.now() - startedAt > MAX_MS) { stop(); return; }
      input.setAttribute('placeholder', 'Try “' + word.slice(0, n) + (n < word.length ? '' : '”'));
      if (n < word.length) timer = setTimeout(function () { type(word, n + 1, done); }, 60);
      else timer = setTimeout(done, Math.max(0, Math.min(1500, MAX_MS - (Date.now() - startedAt))));
    }

    function cycle() {
      if (!names || !names.length || shownThisOpen >= MAX_NAMES) { stop(); return; }
      shownThisOpen++;
      var word = names[i++ % names.length];
      type(word, 1, cycle);
    }

    // Runs once each time the drawer opens, never again until it has closed.
    var wasOpen = false;
    new MutationObserver(function () {
      var open = drawer.classList.contains('sidebar--opened');
      if (open && !wasOpen) {
        shownThisOpen = 0;
        load().then(function () {
          if (!timer && drawer.classList.contains('sidebar--opened')) {
            startedAt = Date.now() + 500;
            timer = setTimeout(cycle, 500);
          }
        });
      } else if (!open && wasOpen) {
        stop();
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    input.addEventListener('input', function () { if (input.value) stop(); });
    input.addEventListener('keydown', function () { if (timer) stop(); });
  }

  /* ---------- Start ---------- */

  onReady(function () {
    onScroll();
    enhanceVariants();
    watchProduct();
    watchCart();
    viewCursor();
    searchPlaceholder();
  });
})();
